module.exports = __webpack_public_path__ + "static/media/playgateway.052f5360.svg";